import { SEARCH_URL } from '@/constants';
import { ForbiddenError, UnauthorizedError, UnexpectedError, UnprocessableEntity } from '@/services';
import { FormRisk, RiskModel } from '@/types';
import { HttpStatusCode, fromRiskBff, httpClient } from '@/utils';

export const updateSearchService = async (data: FormRisk | RiskModel, formId: string): Promise<void> => {
  const headers = { 'gr-create-request-key': formId };
  const uri = `${fromRiskBff(SEARCH_URL)}/${data.uuid}`;
  const { status } = await httpClient.put(uri, data, { headers });

  switch (status) {
    case HttpStatusCode.created:
      break;

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    case HttpStatusCode.forbidden:
      throw new ForbiddenError();

    case HttpStatusCode.unprocessableEntity:
      throw new UnprocessableEntity('Não foi possível fazer o envio, verifique os campos e tente novamente');

    default:
      throw new UnexpectedError(status);
  }
};
